import { render, staticRenderFns } from "./PrazoPagamentoList.vue?vue&type=template&id=74f45ff3&scoped=true"
import script from "./PrazoPagamentoList.vue?vue&type=script&lang=js"
export * from "./PrazoPagamentoList.vue?vue&type=script&lang=js"
import style0 from "./PrazoPagamentoList.vue?vue&type=style&index=0&id=74f45ff3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f45ff3",
  null
  
)

export default component.exports